import { faBarcode, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { BUREAU_BARCODE_FORMAT, LOCALSTORAGE_KEYS } from 'src/utils/constants';
import routes from 'src/utils/routes';
import useLocalstorage from 'src/utils/useLocalStorage';

const ScanButton = ({ withWrapper }) => {
  const [scanMode] = useLocalstorage(LOCALSTORAGE_KEYS.SCAN_MODE, BUREAU_BARCODE_FORMAT.QR);
  const scanIcon = scanMode === BUREAU_BARCODE_FORMAT.BARCODE ? faBarcode : faQrcode;
  const Button = (
    <Link to={routes.scan}>
      <button
        type='button'
        className='piece-overview-action-button piece-overview-action-button--scan'
      >
        <FontAwesomeIcon icon={scanIcon} className='piece-overview-action-button__icon' />
        New Scan
      </button>
    </Link>
  );

  if (withWrapper) {
    return <div className='text-center mt15'>{Button}</div>;
  }

  return Button;
};

ScanButton.propTypes = {
  withWrapper: PropTypes.bool,
};

ScanButton.defaultProps = {
  withWrapper: true,
};

export default ScanButton;
